import { CSSProperties, FC } from 'react';
import { useSearchParams } from 'react-router-dom';

import ChatRoomDetail from 'src/components/Channel/ChatRoom/ChatRoomDetail';

import { useTitle } from '../hooks/useTitle';
import { useAuth } from '../stores/auth-context';

const centeredMessageStyle: CSSProperties = {
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const ChatRoomPopupPage: FC = () => {
  useTitle('GU 매장 채팅');
  const [searchParams] = useSearchParams();
  const channelId = searchParams.get('channelId') ?? undefined;
  const { isLoggedIn, authLoading } = useAuth();

  if (authLoading) return null;

  if (!isLoggedIn) {
    return <div style={centeredMessageStyle}>로그인이 필요합니다.</div>;
  }

  if (!channelId) {
    return <div style={centeredMessageStyle}>채널 정보가 없습니다.</div>;
  }

  return (
    <div style={{ height: '100vh', background: '#fff' }}>
      <ChatRoomDetail channelId={channelId} />
    </div>
  );
};

export default ChatRoomPopupPage;
